import { render, staticRenderFns } from "./OrderConfirmationDescription.vue?vue&type=template&id=eeb73564"
import script from "./OrderConfirmationDescription.vue?vue&type=script&lang=js"
export * from "./OrderConfirmationDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports